export default {
  label: {
    statusHeader: 'Status',
    transitionsHeader: 'Transições',
  },
};
